import React, { Component } from 'react';
import { Pagination, Button, Table, Tag } from 'antd';
import { ConfigProvider, message } from 'antd';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { apis } from '../api/index.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

import TableEmpty from '../components/TableEmpty.js';
import { setScrollTop, getSex, loadingOptionsHtml } from '../utils';
import throttle from 'lodash.throttle';
import _ from 'lodash';

import AIEvaluate from './AIEvaluate.js';

class AIEvaluateList extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    setApplicationData: PropTypes.func,
    visible: PropTypes.bool,
    user: PropTypes.object,
    onCancel: PropTypes.func,
  };

  constructor(props) {
    super(props);

    let roleInfo = (this.props.user.info.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');
    this.state = {
      list: [],
      isAnonymity,
      roleInfo,
      searchLoading: true,
      total: 0,
      pageNum: 1,
      pageSize: 20,
      detailVisible: false,
      detail: {},
    };

    this.throttledList = throttle(newState => this.getList(newState), 1000);
  }

  componentDidUpdate(prev) {
    const { visible } = this.props;
    if (prev.visible !== visible && visible) this.throttledList({});
  }

  //列表
  getList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = _.pick(updatedState, ['pageNum', 'pageSize']);

    apis.nbReviewList(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') {
        this.setState({ list: res.data.list, total: res.data.total });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //分页
  pageOnChange = pageNum => {
    setScrollTop();
    const newState = { pageNum, searchLoading: true };
    this.throttledList(newState);
  };

  //查看影像
  toImageView = record => {
    this.props.setApplicationData(record);
    let url = `/viewer/study/${record.studyUid}?applicationId=${record.applicationId}&from=report`;
    const w = window.screen.width - 10;
    const h = window.screen.height - 105;

    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(url, 'report', str);
  };

  getColumns = () => {
    let roleInfo = this.props.user.info.operationAuths || '';
    roleInfo = roleInfo.split(',');
    const isAnonymity = roleInfo.includes('S');
    let columns = [
      { title: 'ID', dataIndex: 'diagId', key: 'diagId', width: '10%' },
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: '10%',
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: '10%',
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: '10%',
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },
      {
        title: '检查日期', //检查日期
        dataIndex: 'studyTime',
        key: 'studyTime',
        width: '20%',
        render: value => <>{value || '--'}</>,
      },
      {
        title: '申请日期', //申请日期
        dataIndex: 'applicationTime',
        key: 'applicationTime',
        width: '20%',
        render: value => <>{value || '--'}</>,
      },
      {
        title: 'AI筛查',
        key: 'nboxAiConfidence',
        className: 'nboxAiConfidence',
        width: '10%',
        render: record => {
          const { nboxAiConfidence } = record;
          if (typeof nboxAiConfidence !== 'number') return <>--</>;
          const label = nboxAiConfidence >= 0.5 ? '异常' : '正常';
          return (
            <Tag color={nboxAiConfidence >= 0.5 ? '#E14B4B' : '#4BD184'}>
              {label}
            </Tag>
          );
        },
      },
      {
        title: '操作', //操作
        dataIndex: '',
        key: 'id',
        width: '10%',
        render: record => (
          <Button type="link" onClick={() => this.handleEvaluate(record)}>
            立即评价
          </Button>
        ),
      },
    ];

    return columns;
  };

  handleEvaluate = detail => {
    this.toImageView(detail);
    this.setState({ detail, detailVisible: true });
  };

  hideEvaluate = changed => {
    this.setState({ detailVisible: false });

    if (changed) this.throttledList({});
  };

  render() {
    let { list } = this.state;

    const columns = this.getColumns();

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    return (
      <Modal
        title="我的待评价"
        visible={this.props.visible}
        width="80%"
        height="700px"
        centered
        className="evaluate-modal"
        onCancel={() => this.props.onCancel()}
        footer={null}
      >
        <Table
          loading={loadingOptions}
          columns={columns}
          dataSource={list}
          rowKey={record => record.id}
          key={record => record.id}
          pagination={false}
          className="list-item report-list-item"
          scroll={{ y: 480 }}
          locale={{ emptyText: <TableEmpty /> }}
        />
        <ConfigProvider locale={zh_CN}>
          <Pagination
            onChange={this.pageOnChange}
            total={this.state.total}
            pageSize={20}
            className="list-page"
            current={this.state.pageNum}
            showTotal={() => `共${this.state.total}条`}
            size="small"
          ></Pagination>
        </ConfigProvider>
        <AIEvaluate
          visible={this.state.detailVisible}
          diagId={this.state.diagId}
          detail={this.state.detail}
          onCancel={this.hideEvaluate}
        />
      </Modal>
    );
  }
}

export default AIEvaluateList;
